export function createIdGenerator(start = 0) {
  let nextId = start;
  return function generateId() {
    const id = nextId;
    nextId += 1;
    return id;
  };
}

export function sleep(ms = 0) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export const noop = () => {};
